import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  projects = 'projects',
  project = 'project',
  projectChat = 'projectChat',
}

enum ExternalRoutesIds {
  chat = 'chat',
}

// root route
export const projectsRouteRef = createRouteRef({ id: RoutesIds.projects });

export const rootRouteRef = projectsRouteRef;

// sub-routes
export const projectRouteRef = createSubRouteRef({
  id: RoutesIds.project,
  parent: rootRouteRef,
  path: '/:id',
});

export const projectChatRouteRef = createSubRouteRef({
  id: RoutesIds.projectChat,
  parent: rootRouteRef,
  path: '/:id/chats/:chatId',
});

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  projects: projectsRouteRef,
  project: projectRouteRef,
  projectChat: projectChatRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  chat: chatRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
